import { z } from 'zod'

export const topAuthOptionsSchema = z.object({
  identifier: z.string(),
  authority: z.string(),
  scopes: z.array(z.string()),
})
